export default __webpack_public_path__ + "static/media/fifa1.23b26863.gif";